import { render, staticRenderFns } from "./change-theme.vue?vue&type=template&id=55567c42&scoped=true"
import script from "./change-theme.vue?vue&type=script&lang=js"
export * from "./change-theme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55567c42",
  null
  
)

export default component.exports